/**
 * IGNIERE §303（2026-10-10）：スマホで商品画像を指でスワイプしてスクロールした時に、画像の下のサムネの列を追従させる。
 *
 * 症状（代表の実機の指摘）：画像が 5 枚以上の商品で、スワイプで 5 枚目以降へスクロールすると、サムネの列が動かず、
 * 選ばれたサムネが画面の右の外に出たままになる（選択の属性 aria-selected は正しく移っている）。
 *
 * 原因：Horizon の slideshow.js は、サムネを押した時（select）とマウスで引っ張った時（pointerup）だけ
 * #centerSelectedThumbnail を呼び、指のスワイプ＝ブラウザ任せのスクロール（#handleScroll・trigger 'scroll'）では
 * 呼ばない。4.1.1 でも upstream の 4.2.0 でも同じ。コアは編集しない（HANDOFF §3）ので、コアが出す
 * slideshow:select のイベントを受けて、同じ計算（選ばれたサムネを列の中央へ）をここで行う。
 *
 * §81 の色の絞り込みで隠れたサムネ（display:none）は幅 0 になるだけで、選ばれたサムネの位置の計算には影響しない。
 */
(() => {
  'use strict';

  const center = (component) => {
    const container = component.querySelector('.slideshow-controls__thumbnails-container');
    if (!(container instanceof HTMLElement)) return;
    const selected = container.querySelector('.slideshow-controls__thumbnail[aria-selected="true"]');
    if (!(selected instanceof HTMLElement)) return;

    const c = container.getBoundingClientRect();
    const s = selected.getBoundingClientRect();
    const left =
      container.scrollWidth > container.clientWidth
        ? container.scrollLeft + s.left - c.left - container.clientWidth / 2 + s.width / 2
        : container.scrollLeft;
    const top =
      container.scrollHeight > container.clientHeight
        ? container.scrollTop + s.top - c.top - container.clientHeight / 2 + s.height / 2
        : container.scrollTop;
    container.scrollTo({ left, top, behavior: 'smooth' });
  };

  document.addEventListener('slideshow:select', (event) => {
    /* 押した時・引っ張った時はコアが自分でスクロールするので、二重に動かさない */
    if (event.detail?.trigger !== 'scroll') return;
    const component = event.target instanceof Element ? event.target.closest('slideshow-component') : null;
    if (!component) return;
    /* スワイプのイベントはコアが current（aria-selected）を書き換えた後に出るが、描画の後に測る方が確実 */
    requestAnimationFrame(() => center(component));
  });
})();
